var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18.667,
    viewBox: "0 0 28 18.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#003d5b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -85.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 85.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.865,213.484l-6.829,6c-.009.008-.018.016-.026.024a1.167,1.167,0,0,0,.824,1.993,1.183,1.183,0,0,0,.851-.369l6-6.829a.583.583,0,0,0-.824-.823Z",
    transform: "translate(-221.834 -206.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,85.333A14,14,0,0,0,.665,103.594a.584.584,0,0,0,.556.406H26.779a.584.584,0,0,0,.556-.406A14,14,0,0,0,14,85.333ZM25.083,99.916h1.71a12.777,12.777,0,0,1-.447,2.917H1.654a12.777,12.777,0,0,1-.447-2.917h1.71a.583.583,0,0,0,0-1.167H1.2a12.733,12.733,0,0,1,1.419-5.316l1.494.863a.583.583,0,0,0,.583-1.011L3.2,92.425a12.918,12.918,0,0,1,3.891-3.89l.861,1.492a.583.583,0,1,0,1.009-.583L8.1,87.948a12.733,12.733,0,0,1,5.316-1.419v1.72a.583.583,0,0,0,1.167,0v-1.72A12.733,12.733,0,0,1,19.9,87.948l-.863,1.495a.583.583,0,1,0,1.009.583l.861-1.492a12.918,12.918,0,0,1,3.891,3.89l-1.491.861A.583.583,0,0,0,23.89,94.3l1.494-.863A12.734,12.734,0,0,1,26.8,98.75h-1.72a.583.583,0,1,0,0,1.167Z",
    transform: "translate(0 -85.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/iconDashboard.3ce96314074036bfa067cad93e9fc912.svg";
export { ForwardRef as ReactComponent };